import loadScript from './../features/loader';

export function getSwatch(name) {
  const getColors = loadScript({json: window.theme.assets.swatches});
  return getColors.then((colors) => {
    const swatch = buildSwatch(colors, name);
    return swatch;
  }).catch((e) => {
    console.log('failed to load swatch colors script');
    console.log(e);
  });
}

function buildSwatch(colors, name) {
  let bg = '#E5E5E5';
  let img = null;
  const path = window.theme.assets.base || '/';
  const comparisonName = name.toLowerCase().replace(/\s/g, '');
  const array = colors.colors;
  if (array) {
    const variantNameMatch = (nameObject) => {
      const indexName = Object.keys(nameObject).toString();
      const neatName = indexName.toLowerCase().replace(/\s/g, '');
      return neatName === comparisonName;
    };
    const position = array.findIndex(variantNameMatch);
    if (position > -1) {
      const value = Object.values(array[position])[0];
      if (value.includes('.jpg') || value.includes('.jpeg') || value.includes('.png') || value.includes('.svg')) {
        img = `${path}${value}`;
        bg = '#888888';
      } else {
        bg = value;
      }
    }
  }
  return {
    path: img,
    hex: bg,
  };
}
